import React, { useEffect } from 'react';
import PageSeo from '@framework/seo/PageSeo';
import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';
import MetaSchema from '@/creditflowresearch/ui/common/components/MetaSchema';
import config from '@creditflowresearch/config';
import getMetaSchema from './getMetaSchema';
import Intro from '@/creditflowresearch/ui/common/components/templates/Intro';
import FaqPanel from '@/creditflowresearch/ui/components/staticPages/Pricing/FaqPanel';
import data from './FaqPanel/FaqData';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import TabsSlider from '@framework/ui/Pages/Landing/Sections/TabsSlider';
import { sectionOne, sectionTwo } from './MainSection/tabs';
import { IClassNames } from '@framework/ui/Pages/Landing/Sections/TabsSlider/interface';
import { CreditflowresearchTenant } from '@/creditflowresearch/domain/vo/types/CreditflowresearchTenant';
import { LogoCreditFlowResearchStandart } from '@creditflowresearch/uilib/Logo/CreditFlowResearch/Standart';
import BookDemoButton from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModal/BookDemoButton';
import { useBookDemo } from '@/creditflowresearch/ui/common/components/atoms/BookDemoButton';
import { useMetaTagsContext } from '@/creditflowresearch/application/MetaTags/MetaTagsContext';

import styles from './styles.module.scss';

const classNames: IClassNames = {
  imgClassName: styles.img,
  slidersWrapper: styles.slidersWrapper,
  imgLabelClassName: styles.imgLabelClassName,
};

const Homepage = () => {
  const openBookDemo = useBookDemo();
  const { setMetaTags } = useMetaTagsContext();

  useEffect(() => {
    setMetaTags({
      ...metaTags.getHomePage(),
      withSuffix: false,
    });
  }, []);

  return (
    <>
      <MetaSchema schema={ getMetaSchema() } />
      <PageSeo { ...getMetaSchema() } { ...metaTags.getHomePage() } />
      <div className={ styles.mainContainer }>
        <div className={ styles.introContainer }>
          <Intro />
        </div>
        <div className={ styles.mainSectionContainer }>
          <SectionContainer className={ styles.section }>
            <SectionHeader
              className={ styles.headerWrapper }
              title={ (
                <>
                  <div className={ styles.sectionHeaderTitle }>How CreditFlow Differentiates</div>
                </>
              ) }
              description="CreditFlow delivers new issue announcements, guidance and pricings directly to your inbox as they happen. Instantly search and analyze millions of recent and historical new issue data points with dozens of filters, dynamic charting and real-time email alerts, all on one platform."
              maxWidth={ 915 }
            />
          </SectionContainer>
          <SectionContainer size="large" narrow>
            <TabsSlider
              content={ sectionOne }
              classNames={ classNames }
              classNamesDots={ styles.dots }
            />
            <TabsSlider
              content={ sectionTwo }
              isReversedPosition
              classNames={ {
                ...classNames,
                imgLabelClassName: styles.imgLabelWithMarginClassName,
                imgClassName: styles.imgSmall,
                titleClassName: styles.titleClassName,
              } }
            />
          </SectionContainer>
          <BookDemoButton
            className={ styles.button }
            tenant={ config.code as CreditflowresearchTenant }
            logoComponent={ LogoCreditFlowResearchStandart }
            title="Book Demo"
            openModalWithUrl={ openBookDemo }
          />
        </div>
        <div className={ styles.faqContainer }>
          <div className={ styles.faqWrapper }>
            <FaqPanel data={ data } />
          </div>
        </div>
      </div>
    </>
  );
};

export default Homepage;
